import { get } from 'lodash';

import { YardTaskAttachmentAction } from '@nova/core';

import type { YardTaskTimelineEvent } from './types';

/**
 * Determines what happened to the attachment. One event type covers both directions, so the
 * action is read from the payload rather than the event name.
 * @param {YardTaskTimelineEvent} event - The attachments-updated event
 * @returns {YardTaskAttachmentAction} The recorded action, defaulting to added
 */
export function getAttachmentAction(event: YardTaskTimelineEvent): YardTaskAttachmentAction {
  return get(event, 'data.data.action') === YardTaskAttachmentAction.REMOVED
    ? YardTaskAttachmentAction.REMOVED
    : YardTaskAttachmentAction.ADDED;
}
